import { ContextState, Dictionary, Filter, GetterClass } from '../../../models';

export class EnabledFiltersGetter implements GetterClass {

  public static execute(state: ContextState): Dictionary<Filter> {
    const enabledFilters: Dictionary<Filter> = {};
    Object.values(state.filters).forEach((filter: Filter) => {
      if (filter.config.enabled) {
        enabledFilters[filter.config.id] = filter;
      }
    });
    return enabledFilters;
  }

}
